/**
 * Cut off anything after the first 6 hexadecimal digits using bitmask (&),
 * convert to hex string, and pad with zeros.
 * We are guaranteed length 6 (RGB).
 * https://developer.mozilla.org/en-US/docs/Web/CSS/hex-color#syntax
 */
export function intToHexRGB(int: number) {
  return `#${(int & 0xFFFFFF).toString(16).padStart(6, '0')}`;
}

/**
 * Cut off anything after the first 8 hexadecimal digits using bitmask (&),
 * convert to hex string, and pad with zeros.
 * We are guaranteed length 8 (RGBA).
 * https://developer.mozilla.org/en-US/docs/Web/CSS/hex-color#syntax
 */
export function intToHexRGBA(int: number) {
  return `#${(int & 0xFFFFFFFF).toString(16).padStart(8, '0')}`;
}

/**
 * https://stackoverflow.com/a/21010385
 * interpolate 2 RGB colors
 *
 * @param color1    integer containing color as 0x00RRGGBB
 * @param color2    integer containing color as 0x00RRGGBB
 * @param fraction  how much interpolation (0..1)
 * - 0: full color 1
 * - 1: full color 2
 * @return the new color after interpolation
 */
export function lerpColor(color1: number, color2: number, fraction: number) {
  const r1 = (color1 >> 16) & 0xff;
  const r2 = (color2 >> 16) & 0xff;
  const g1 = (color1 >> 8) & 0xff;
  const g2 = (color2 >> 8) & 0xff;
  const b1 = color1 & 0xff;
  const b2 = color2 & 0xff;

  return ((((r2 - r1) * fraction) + r1) << 16) |
    ((((g2 - g1) * fraction) + g1) << 8) |
    (((b2 - b1) * fraction) + b1);
}
